module.exports = __webpack_public_path__ + "img/漏洞扫描工具.80167a17.png";